import { Component, EventEmitter, Input, OnInit, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor } from '@ngneat/reactive-forms';
import { Observable, Subject, concat, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { Member, MemberService } from 'src/app/apis/member.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { formPage } from 'src/app/utils/functions/form-page';

@Component({
  selector: 'app-agent-select-member-from',
  templateUrl: './agent-select-member-from.component.html',
  styleUrls: ['./agent-select-member-from.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AgentSelectMemberFromComponent),
      multi: true
    }
  ]
})
export class AgentSelectMemberFromComponent extends AppCore implements ControlValueAccessor {
  value = undefined;

  member$: Observable<Member[]>;
  memberLoading = false;
  memberInput$ = new Subject<string>();

  @Input() emptyIsAll = false;
  @Output() change = new EventEmitter<Member>(undefined);
  constructor(
    private svMember: MemberService,
  ) {
    super();
  }

  currentAgentChanged(): void {
    if (this.currentAgent?.id) {
      this.member$ = concat(
        of([]),
        this.memberInput$.pipe(
          distinctUntilChanged(),
          tap(() => this.memberLoading = true),
          switchMap(search => {
            if (!search || !search.trim()) {
              this.memberLoading = false;
              return of([]);
            }
            const form = formPage({ ask4betAgentId: (this.currentAgent?.id || '') + '', name: 'username', filter: (search + '').trim() });
            return this.svMember.getMembers(form.getRawValue()).pipe(
              map(data => this.sortMemberItems(data?.items || [])),
              catchError(() => of([])),
              tap(() => this.memberLoading = false),
            );
          }),
        ),
      );
    }
  }

  writeValue(value: any): void {
    this.value = value;
  }

  onChange?: (value: any) => void;

  onTouched?: () => void;

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  onSelectChange(event: Member) {
    this.change.emit(event);
  }

  sortMemberItems(items: Member[]) {
    return items.sort((a, b) => {
      const aName = a.username.toUpperCase();
      const bName = b.username.toUpperCase();
      if (aName < bName) {
        return -1;
      }
      if (aName > bName) {
        return 1;
      }
      return 0;
    });
  }
}
